module.exports = __webpack_public_path__ + "img/siteschart.4567e6bf.png";